module.exports = {"610724001":"城北街道","610724002":"城南街道","610724101":"杨河镇","610724102":"柳树镇","610724103":"沙河镇","610724104":"私渡镇","610724105":"桑园镇","610724106":"白龙塘镇","610724108":"峡口镇","610724109":"堰口镇","610724110":"茶镇","610724111":"高川镇","610724112":"两河口镇","610724114":"大河镇","610724116":"骆家坝镇","610724117":"子午镇","610724118":"白勉峡镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610724.json
// module id = 2642
// module chunks = 0